import axios from 'api/axios'
import { Template } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

export const getSingleTemplate = async (id: string) => {
	try {
		const { data } = await axios.get<Template>(`templates/list/${id}/view`)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getSingleTemplate
